import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a4eec68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-mx-2" }
const _hoisted_5 = { class: "p-mx-2" }
const _hoisted_6 = { class: "st-style p-text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_8 = { class: "p-buttonset" }
const _hoisted_9 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_10 = { class: "p-grid" }
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "p-error" }
const _hoisted_15 = {
  key: 1,
  class: "p-error"
}
const _hoisted_16 = { class: "p-col" }
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "p-error" }
const _hoisted_20 = {
  key: 1,
  class: "p-error"
}
const _hoisted_21 = { class: "p-field" }
const _hoisted_22 = { class: "p-grid" }
const _hoisted_23 = { class: "p-col-8 p-text-left" }
const _hoisted_24 = { class: "p-col-4 p-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SearchFilter = _resolveComponent("SearchFilter")!
  const _component_PreviewReceipt = _resolveComponent("PreviewReceipt")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            false
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 0,
                  modelValue: _ctx.itemFilter.type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemFilter.type) = $event)),
                  options: _ctx.voucherTypes,
                  optionLabel: "value",
                  optionValue: "key",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList(0)))
                }, null, 8, ["modelValue", "options"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.itemFilter.keyword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemFilter.keyword) = $event)),
              modelModifiers: { trim: true },
              placeholder: "Voucher No"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              icon: "pi pi-search ",
              class: "p-button-primary p-mr-1",
              onClick: _ctx.loadSearchData
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-calendar",
              class: "p-button-warning",
              onClick: _ctx.openFilterDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              class: "p-button-success",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("b", null, _toDisplayString(_ctx.statement), 1)
      ]),
      _createVNode(_component_DataTable, {
        first: _ctx.goToFirstLink,
        "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
        firstModifiers: { sync: true },
        value: _ctx.lists,
        lazy: true,
        paginator: _ctx.checkPagination,
        rows: _ctx.limit,
        totalRecords: _ctx.totalRecords,
        scrollable: true,
        onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
      }, {
        empty: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "Created Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.created_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Updated Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.updated_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Voucher Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.voucher_date)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "voucher_no",
            header: "Voucher No"
          }),
          _createVNode(_component_Column, {
            field: "profiler.account_title",
            header: "Account Title"
          }),
          _createVNode(_component_Column, { header: "Total Amount" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(slotProps.data.total_amount)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "memo",
            header: "Description"
          }),
          _createVNode(_component_Column, {
            field: "user_name.userName",
            header: "Created By"
          }),
          _createVNode(_component_Column, { header: "Store Name" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.branch.branchName) + " ( " + _toDisplayString(slotProps.data.branch.branchCode) + " ) ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", _hoisted_8, [
                (_ctx.editVoucherPermission)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-pencil",
                      class: "p-button-rounded p-button-success",
                      onClick: ($event: any) => (_ctx.editIem(slotProps.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Button, {
                  icon: "pi pi-print",
                  class: "p-button-rounded p-button-primary",
                  onClick: ($event: any) => (_ctx.openPreviewDialog(slotProps.data))
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["first", "value", "paginator", "rows", "totalRecords"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '100vw' },
        position: "top",
        class: "p-fluid p-m-0 p-dialog-maximized"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.dialogTitle), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              false
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    type: "button",
                    label: "Clear All Items",
                    icon: "pi pi-times",
                    class: "p-button-danger pull-left",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearLines()))
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                type: "button",
                label: 'Total Amount : '+_ctx.currency+' ' + _ctx.fixDigits(_ctx.totalVoucherAmount),
                class: "p-button-warning"
              }, null, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              false
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    type: "button",
                    label: "Add New Line",
                    icon: "pi pi-plus-circle",
                    class: "p-button-success",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addNewLine()))
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                type: "submit",
                label: "Save",
                disabled: 
                  _ctx.item.profileID == 0 || _ctx.state.voucherDate == '' ||
                  _ctx.state.itemList.length <= 0 || _ctx.state.itemList.forEach((v) => {
                      if(v.accountID == 0){
                        return true;
                      };
                    }) ||
                  _ctx.totalVoucherAmount <= 0
                ,
                icon: "pi pi-check",
                class: "p-button-primary",
                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
              }, null, 8, ["disabled"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", {
                  for: "voucherDate",
                  class: _normalizeClass({ 'p-error': _ctx.v$.voucherDate.$invalid && _ctx.submitted })
                }, "Voucher Date", 2),
                _createVNode(_component_Calendar, {
                  id: "voucherDate",
                  modelValue: _ctx.v$.voucherDate.$model,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.voucherDate.$model) = $event)),
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.voucherDate.$invalid && _ctx.submitted }),
                  dateFormat: "dd-mm-yy",
                  manualInput: false,
                  minDate: new Date(new Date().setDate(new Date().getDate() - 90)),
                  maxDate: new Date()
                }, null, 8, ["modelValue", "class", "minDate", "maxDate"]),
                (_ctx.v$.voucherDate.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.voucherDate.$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_14, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                  (_ctx.v$.voucherDate.$invalid && _ctx.submitted) ||
                  _ctx.v$.voucherDate.$pending.$response
                )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.v$.voucherDate.required.$message.replace(
                    "Value",
                    "Voucher Date"
                  )), 1))
                    : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", {
                  for: "description",
                  class: _normalizeClass({ 'p-error': _ctx.v$.description.$invalid && _ctx.submitted })
                }, "Description", 2),
                _createVNode(_component_InputText, {
                  id: "description",
                  modelValue: _ctx.v$.description.$model,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.description.$invalid && _ctx.submitted })
                }, null, 8, ["modelValue", "class"]),
                (_ctx.v$.description.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.description.$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_19, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                  (_ctx.v$.description.$invalid && _ctx.submitted) ||
                  _ctx.v$.description.$pending.$response
                )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_ctx.v$.description.required.$message.replace(
                    "Value",
                    "Description"
                  )), 1))
                    : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_DataTable, {
              value: _ctx.state.itemList,
              class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
              responsiveLayout: "scroll"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  header: "VOUCHER TYPE",
                  style: {"width":"75%"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Dropdown, {
                      modelValue: slotProps.data.accountID,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.accountID) = $event),
                      placeholder: "Please select",
                      options: _ctx.accountHeadList,
                      optionLabel: "account_name",
                      optionValue: "id",
                      onChange: ($event: any) => (_ctx.saveAccountHead($event, slotProps.data))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: 'AMOUNT ('+_ctx.currency+')',
                  style: {"width":"20%"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_InputNumber, {
                      mode: "decimal",
                      maxFractionDigits: 2,
                      minFractionDigits: 2,
                      modelValue: slotProps.data.totalAmount,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.totalAmount) = $event),
                      class: "p-p-1"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                false
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 0,
                      header: "Action",
                      style: {"width":"5%"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-times",
                          class: "p-button-danger pull-left",
                          onClick: ($event: any) => (_ctx.clearListItem(slotProps.data))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_SearchFilter, {
        searchDetail: {
          status: this.filterDialog,
          dialogTitle: this.dialogTitle,
        },
        onUpdateFilterStatus: _ctx.updateFilterStatus
      }, null, 8, ["searchDetail", "onUpdateFilterStatus"]),
      _createVNode(_component_PreviewReceipt, {
        PreviewReceipt: {
          status: this.previewImageDialog,
          dialogTitle: this.dialogTitle,
          previewHeading: this.previewHeading,
          receiptID: this.receiptID,
        },
        onUpdatePreviewStatus: _ctx.updatePreviewStatus
      }, null, 8, ["PreviewReceipt", "onUpdatePreviewStatus"])
    ])
  ]))
}